import {Component, Injector} from "@angular/core";
import {NotificationsDialogBaseComponent} from "./notifications-dialog-base/notifications-dialog-base.component";

@Component({
    selector: 'app-create-notification',
    templateUrl: './notifications-dialog-base/notifications-dialog-base.component.html',
    styleUrls: ['./notifications-dialog-base/notifications-dialog-base.component.css'],
    standalone: false
})
export  class CreateNotificationComponent extends NotificationsDialogBaseComponent{
  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createNotification";
  }

  public submit() {
    this.model.Id = 0;
    this.service.create(this.model).subscribe(() => {
        this.onCreated.emit();
        this.close();
        super.submit();
      });
  }
}
